import { motion } from "framer-motion";

// Splits text into words and animates them line-by-line with a mask reveal.
export const RevealText = ({
    text,
    className = "",
    delay = 0,
    stagger = 0.06,
    as: Tag = "span",
    testid,
}) => {
    const words = text.split(" ");
    return (
        <Tag className={className} data-testid={testid}>
            {words.map((word, i) => (
                <span key={i} className="reveal-mask mr-[0.28em]">
                    <motion.span
                        className="inline-block"
                        initial={{ y: "110%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration: 0.9,
                            delay: delay + i * stagger,
                            ease: [0.65, 0, 0.35, 1],
                        }}
                    >
                        {word}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
};

export const RevealLines = ({ lines = [], className = "", delay = 0, testid }) => (
    <div className={className} data-testid={testid}>
        {lines.map((line, i) => (
            <div key={i} className="reveal-mask block leading-[0.95]">
                <motion.span
                    className="inline-block"
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{
                        duration: 1.1,
                        delay: delay + i * 0.15,
                        ease: [0.65, 0, 0.35, 1],
                    }}
                >
                    {line}
                </motion.span>
            </div>
        ))}
    </div>
);

export default RevealText;
